// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialMediaButtons_wrapper__lluan","socialLink":"SocialMediaButtons_socialLink__T8Usf"};